export const checkUserVerified = (user) => {
  return user?.is_active?.toString().toLowerCase() === 'true';
};